'use client';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';

const FixedToastContainer = ToastContainer;
export default FixedToastContainer;